module.exports = __webpack_public_path__ + "img/without_matress.d2e6641f.jpg";